
export const SHIPMENT_LIST_RIGHT_MENU = {
    SET_STATE_MENU: 'SHIPMENT_LIST_RIGHT_MENU.SET_STATE_MENU',
    SET_INITIAL_DATE: 'SHIPMENT_LIST_RIGHT_MENU.SET_INITIAL_DATE',
    SET_FINAL_DATE: 'SHIPMENT_LIST_RIGHT_MENU.SET_FINAL_DATE',
    SET_SITUATIONS: 'SHIPMENT_LIST_RIGHT_MENU.SET_SITUATIONS',
    SET_ID_MENU_SELECTION: 'SHIPMENT_LIST_RIGHT_MENU.SET_ID_MENU_SELECTION'
}